import { memo, useImperativeHandle, useState } from 'react'

import { Checkbox, TextArea } from 'basic-components'

import { When } from 'react-if'

import './SendMessage.scss'

const SendMessage = ({ ref }) => {
  const [shouldSendMessage, setShouldSendMessage] = useState(false),
        [message, setMessage] = useState()

  useImperativeHandle(ref, () => ({
    shouldSendMessage: () => shouldSendMessage,
    getMessage: () => {
      if(shouldSendMessage) {
        return message
      }
      return undefined
    }
  }))

  return (
    <div className="data-lake__group-dialog__edit-access__send-message">
      <Checkbox
          checked={shouldSendMessage}
          onChange={setShouldSendMessage}
      >
        Notify users
      </Checkbox>
      <When condition={shouldSendMessage}>
        {() => (
          <div className="data-lake__group-dialog__edit-access__send-message__section">
            <TextArea
                defaultValue={message}
                name="newShareMessage"
                onChange={setMessage}
                placeholder="Type message"
                size="large-low"
                variant="border"
            />
          </div>
        )}
      </When>
    </div>
  )
}

export default memo(SendMessage)
